/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Footer accordion: collapsed on mobile, always expanded on desktop
(function () {
  const footerAccordion = document.querySelector('accordion-group.footer__accordion');
  if (!footerAccordion) return;

  const mobileQuery = window.matchMedia('(max-width: 47.9275em)');

  const getFooterDetails = () =>
    footerAccordion.querySelectorAll('.footer-nav__details');

  const syncFooterLayout = () => {
    const isMobile = mobileQuery.matches;

    footerAccordion.classList.toggle(
      'footer__accordion--desktop-expanded',
      !isMobile
    );

    getFooterDetails().forEach((details) => {
      if (isMobile) {
        details.removeAttribute('open');
        details.style.height = '';
        details.style.overflow = '';
      } else {
        details.setAttribute('open', '');
        details.style.height = '';
        details.style.overflow = '';
      }
    });
  };

  syncFooterLayout();
  mobileQuery.addEventListener('change', syncFooterLayout);
  window.addEventListener('load', syncFooterLayout);

  footerAccordion.addEventListener(
    'on:accordion:opening',
    (event) => {
      if (!mobileQuery.matches) return;

      const openingDetails = event.target;
      if (!(openingDetails instanceof HTMLDetailsElement)) return;

      footerAccordion.querySelectorAll('details[open]').forEach((details) => {
        if (details !== openingDetails && details.id) {
          footerAccordion.close(details.id);
        }
      });
    },
    true
  );
})();

// Shopify Inbox: shrink #ShopifyChat on mobile when closed (CSS scale property)
(function () {
  const CHAT_SCALE = 0.8;
  const CHAT_ORIGIN = 'bottom left';
  const mobileQuery = window.matchMedia('(max-width: 61.24em)');

  const CHAT_HOST_SELECTORS = ['#ShopifyChat', 'inbox-online-store-chat'];

  function getChatHosts() {
    const hosts = new Set();
    CHAT_HOST_SELECTORS.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => hosts.add(el));
    });
    return [...hosts];
  }

  function isChatOpen(el) {
    return el.getAttribute('is-open') === 'true';
  }

  function setScaled(el) {
    el.style.setProperty('scale', String(CHAT_SCALE), 'important');
    el.style.setProperty('transform-origin', CHAT_ORIGIN, 'important');
  }

  function clearScaled(el) {
    el.style.removeProperty('scale');
    el.style.removeProperty('transform-origin');
    el.style.removeProperty('transform');
  }

  function applyMobileChatScale() {
    const hosts = getChatHosts();

    if (!mobileQuery.matches) {
      hosts.forEach(clearScaled);
      return;
    }

    hosts.forEach((el) => {
      if (isChatOpen(el)) clearScaled(el);
      else setScaled(el);
    });
  }

  applyMobileChatScale();
  mobileQuery.addEventListener('change', applyMobileChatScale);
  window.addEventListener('load', applyMobileChatScale);
  document.addEventListener('shopify:section:load', applyMobileChatScale);

  const chatObserver = new MutationObserver(applyMobileChatScale);
  chatObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['is-open'],
  });

  [500, 1500, 3000, 6000, 10000].forEach((delay) => {
    window.setTimeout(applyMobileChatScale, delay);
  });
})();
